import { render, staticRenderFns } from "./WrongAnswers.vue?vue&type=template&id=466cfaee"
import script from "./WrongAnswers.vue?vue&type=script&lang=js"
export * from "./WrongAnswers.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports